import CharityNotice from './CharityNotice';

export default CharityNotice;
